import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Signature on-load reveal — a full-screen curtain that lifts after
 * the fonts and first paint are ready, unveiling the hero.
 */
export default function LoadCurtain() {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setGone(true), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          key="curtain"
          initial={{ y: 0 }}
          exit={{ y: "-101%" }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[60] bg-obsidian flex items-center justify-center"
          data-testid="load-curtain"
        >
          <div className="flex items-baseline gap-3">
            <motion.span
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif text-4xl md:text-5xl italic font-light text-cream"
            >
              BB
            </motion.span>
            <motion.span
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.28, ease: [0.16, 1, 0.3, 1] }}
              className="text-[0.72rem] uppercase tracking-[0.5em] text-gold"
            >
              fit
            </motion.span>
          </div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.1, ease: "easeInOut" }}
            className="absolute bottom-16 left-1/2 -translate-x-1/2 h-px w-40 bg-gold origin-left"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
